import { render, staticRenderFns } from "./SchedulingArchive.vue?vue&type=template&id=82595120"
import script from "./SchedulingArchive.vue?vue&type=script&lang=js"
export * from "./SchedulingArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports